import React, { useEffect, useState } from "react";
import UserScreenWindow from "../Components/UserScreenWindow";
import { getAllDocsSnap } from "../../../utils/firebase/Firebase.utils";
import ContactCard from "./ContactCard";
import ContactDetailsModal from "./ContactDetailsModal";
import { useCompany } from "../../../context/CompanyContext";
import { hoaLabel } from "../../../utils/constants";

function HoaDirectory() {
  const [hoaContacts, setHoaContacts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedContact, setSelectedContact] = useState(null);
  const { getCapitalizedTerm } = useCompany();

  useEffect(() => {
    const fetchContacts = async () => {
      await getAllDocsSnap("contacts", (data) => {
        const filteredData = data.filter(
          (contact) => contact.category === `${hoaLabel} Directory`
        );
        //sort by name
        filteredData.sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
        setHoaContacts(filteredData);
        setIsLoading(false);
      });
    };
    fetchContacts();
  }, []);

  const filteredItems = hoaContacts.filter((contact) => {
    return (
      contact?.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      contact?.title.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  return (
    <UserScreenWindow label={`${getCapitalizedTerm("type")} Directory`}>
      <div className="font-bold text-blue-900 text-sm text-center mt-8 header">
        Condo Corp Directory
      </div>

      <div className="mt-4">
        <div className="p-2 rounded-lg bg-white">
          <input
            type="search"
            className="w-full p-2 border border-gray-200 rounded-lg"
            placeholder="Search"
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      <div className="mt-4 space-y-2">
        {isLoading ? (
          <div>Loading...</div>
        ) : (
          filteredItems.map((contact, index) => (
            <ContactCard
              key={index}
              contact={contact}
              onClick={() => setSelectedContact(contact)}
            />
          ))
        )}
      </div>

      {selectedContact && (
        <ContactDetailsModal
          contact={selectedContact}
          onClose={() => setSelectedContact(null)}
        />
      )}
    </UserScreenWindow>
  );
}

export default HoaDirectory;
